import React from 'react';
import { Modal } from 'react-bootstrap';
// import { SimpleCenteredModal } from '../Utils/Modal'; // Checking if I can reuse this or if I need a custom one.
// Based on the mockup, it's a simple centered modal with a video player.

const HelpVideoModal = ({ show, onHide, videoUrl }) => {
  const getEmbedUrl = url => {
    if (!url) return '';

    // Handle standard YouTube watch URL
    if (url.includes('youtube.com/watch?v=')) {
      const videoId = url.split('v=')[1]?.split('&')[0];
      return `https://www.youtube.com/embed/${videoId}`;
    }

    // Handle shortened YouTube URL
    if (url.includes('youtu.be/')) {
      const videoId = url.split('youtu.be/')[1]?.split('?')[0];
      return `https://www.youtube.com/embed/${videoId}`;
    }

    return url;
  };

  const embedUrl = getEmbedUrl(videoUrl);

  return (
    <Modal show={show} onHide={onHide} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Reproductor de Video</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-center bg-black">
        {/* Simple iframe for YouTube/Vimeo or HTML5 video depending on URL. Assuming generic iframe for now as per "video_url" */}
        {embedUrl && (
          <div className="embed-responsive embed-responsive-16by9">
            <iframe className="embed-responsive-item" src={embedUrl} title="Video Tutorial" allowFullScreen />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-light" onClick={onHide}>
          Cerrar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default HelpVideoModal;
